enum FeatureFlags {
  ConfLeadCapture = 'is_lead_capture_enabled',
  ConfLeadCaptureLicenseLimit = 'lead_capture_license_limit',
  ConfInteractiveMaps = 'is_interactive_maps_enabled',
  ConfVideoLibraryEnabled = 'is_video_library_enabled',
  GroupRegistrationEnabled = 'group_registration_enabled',
  CustomSystemEmails = 'custom_system_emails',
  BannerImprovements = 'banner_improvements',
  KioskGlobalPasscode = 'kiosk_global_passcode',
  AgendaSessionRoleVisibility = 'agenda_session_role_visibility',
  SessionCompaniesSponsor = 'session_companies_sponsor',
  LoginRedesign = 'exp-login-redesign-enabled',
}

export default FeatureFlags;
